import { render, staticRenderFns } from "./SpotDetailsModal.vue?vue&type=template&id=bb7a006a&scoped=true&"
import script from "./SpotDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SpotDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SpotDetailsModal.vue?vue&type=style&index=0&id=bb7a006a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7a006a",
  null
  
)

export default component.exports